import './App.css';
import { Route, Routes } from "react-router-dom";
import Signin from "./pages/Signin";
// import Sidebar from "./component/Sidebar"
import Dashboard from "./pages/Dashboard";
import "./scss/style.scss";
import "bootstrap/dist/css/bootstrap.css";
import MatterDetails from "./pages/MatterDetails";
import ClientAdress from "./pages/ClientAdress";
import IvyChatboot from "./pages/IvyChatboot";
import Chat from "./pages/Chat";
import ViewDocuments from "./pages/ViewDocuments";
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      {/* <Sidebar /> */}
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Signin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/matter-details/:id" element={<MatterDetails />} />
        <Route path="/client-address" element={<ClientAdress />} />
        <Route path="/document-preview/:id" element={<ViewDocuments />} />
        <Route path="/ivyChatboot" element={<IvyChatboot />} />
        <Route path="/Chat" element={<Chat />} />
      </Routes>
    </div>
  );
}

export default App;
